import { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { Experience } from '@/webapi/use-experience-api';
import { findUnsavedExperienceInDb } from '@/components/hooks/use-cached-auto-save';

export function useUnsavedExperience(alias: string | undefined) {
  const [unsavedExperience, setUnsavedExperience] = useState<Experience | null>(
    null,
  );
  const [isUnsavedExperienceLoading, setIsUnsavedExperienceLoading] =
    useState(true);

  useAsyncEffect(async () => {
    if (!alias) {
      setIsUnsavedExperienceLoading(false);
      setUnsavedExperience(null);
      return;
    }
    try {
      setIsUnsavedExperienceLoading(true);
      const found = await findUnsavedExperienceInDb(alias);
      setUnsavedExperience(found);
    } catch {
      setUnsavedExperience(null);
    } finally {
      setIsUnsavedExperienceLoading(false);
    }
  }, [alias]);

  return { unsavedExperience, isUnsavedExperienceLoading };
}
